<script>
	import { cn } from '$lib/utils';

	let className = '';
	export let text = '';
	export let source = 'Discord bot review';

	export { className as class };
</script>

<div
	class={cn(
		'border-darkTertiary bg-darkSecondary hover:border-darkQuaternary flex h-auto flex-col gap-4 rounded-lg border p-5 shadow-sm transition-colors',
		className
	)}
>
	<p class="text-lightTertiary text-sm font-light">
		{text}
	</p>
	<span class="text-xs font-light text-neutral-500">{source}</span>
</div>
